var _defs, _g, _path, _g2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9af3ab88b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138 327 L 236 327 L 236 369.75 L 138 369.75 Z M 138 327 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a9458a8f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77.34375 0 L 294.84375 0 L 294.84375 344 L 77.34375 344 Z M 77.34375 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9af3ab88b0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a72b",
    d: "M 235.265625 348.574219 C 235.265625 360.03125 213.5 369.316406 186.644531 369.316406 C 159.792969 369.316406 138.027344 360.03125 138.027344 348.574219 C 138.027344 337.128906 159.792969 327.835938 186.644531 327.835938 C 213.5 327.835938 235.265625 337.128906 235.265625 348.574219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd24f",
    d: "M 234.273438 343.554688 C 234.273438 355.011719 212.730469 364.296875 186.148438 364.296875 C 159.570312 364.296875 138.027344 355.011719 138.027344 343.554688 C 138.027344 332.101562 159.570312 322.816406 186.148438 322.816406 C 212.730469 322.816406 234.273438 332.101562 234.273438 343.554688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a9458a8f20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e33924",
    d: "M 188.003906 0.429688 C 187.363281 0.429688 186.730469 0.46875 186.097656 0.484375 C 185.457031 0.46875 184.824219 0.429688 184.183594 0.429688 C 125.152344 0.429688 77.296875 50.261719 77.296875 111.722656 C 77.296875 122.210938 81.367188 146.464844 87.484375 156.527344 L 186.097656 343.554688 L 284.703125 156.527344 C 290.820312 146.464844 294.890625 122.210938 294.890625 111.722656 C 294.890625 50.261719 247.042969 0.429688 188.003906 0.429688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 245.128906 99.324219 C 245.128906 131.886719 218.691406 158.28125 186.097656 158.28125 C 153.492188 158.28125 127.058594 131.886719 127.058594 99.324219 C 127.058594 66.761719 153.492188 40.367188 186.097656 40.367188 C 218.691406 40.367188 245.128906 66.761719 245.128906 99.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationred);
export default __webpack_public_path__ + "static/media/locationred.3dbc9e8f481c3502e2b282c1bcd3d833.svg";
export { ForwardRef as ReactComponent };